import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icons } from '@ohif/ui-next';
import { useAppConfig } from '@state';
import { STUDY_LIST_PATH } from '../../constants/routes';

function SettingsPage() {
  const [appConfig] = useAppConfig();
  const { showStudyList } = appConfig;

  return (
    <div className="bg-background text-foreground flex min-h-screen flex-col">
      <header className="border-input flex h-14 items-center border-b px-6 lg:px-12">
        <Button
          variant="ghost"
          className="gap-2"
          asChild
        >
          <Link to="/">
            <Icons.ChevronLeft className="h-4 w-4" />
            Home
          </Link>
        </Button>
      </header>
      <main className="mx-auto flex w-full max-w-lg flex-1 flex-col px-6 py-12">
        <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
        <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
          Language, hotkeys, and other viewer preferences are available from the header menu when
          you open a study in Radkspace Viewer.
        </p>
        {showStudyList ? (
          <Button
            className="mt-8 w-fit gap-2"
            asChild
          >
            <Link to={STUDY_LIST_PATH}>
              <Icons.ListView className="h-4 w-4" />
              Open study list
            </Link>
          </Button>
        ) : null}
      </main>
    </div>
  );
}

export default SettingsPage;
